module.exports = __webpack_public_path__ + "img/guide11.8c67208b.jpg";